import React from 'react';
import T from 'prop-types';

import SwitchButtons from '../../../../components/SwitchButtons';

const options = [
  { text: 'MoM', value: 'period_over_period' },
  { text: 'YoY', value: 'year_over_year' },
];

const SwitchChangeType = ({ active, disabled, onChange }) => (
  <SwitchButtons
    options={options}
    active={active}
    size="lg"
    disabled={disabled}
    btnClassName="btn btn-outline btn-text"
    containerClassName="btn-group-square type-switcher-large"
    onChange={onChange}
  />
);

SwitchChangeType.propTypes = {
  active: T.string.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default SwitchChangeType;
